import TagManager from '../../../../classes/TagManager';
import styles from './DesktopMinicart.module.scss';
import MiniCartItem from './MiniCartItem';
import GiftMiniCartItem from './GiftMiniCartItem';
import React from 'react';
import { useCartContext } from '../../../../provider/cart/CartContext';
import showLoginErrorMessage from '../../../../utils/showLoginErrorMessage';
import { useOpenSignForm } from '../../../../utils/useOpenSignForm';
import { FORM_TYPE } from '../../../molecules/account/accountDropdown/AccountDropdown';
import { useNostoContext } from '../../../../provider/nosto/NostoContext';

function capitalize(word) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}

const ProductList = ({
  items,
  isLoggedIn,
  setShowDialog,
  setLoading,
  discounts,
}) => {
  const {
    removeFromCart,
    updateCartItem,
    setCartData,
    removeCustomLineItemToCart,
  } = useCartContext();
  const { signFormOpen } = useOpenSignForm();
  const { nostoUpdateCart } = useNostoContext();
  const removeFromCartHandler = (lineItemId, removedItem) => {
    const { type } = removedItem;

    if (type === 'gift-card') {
      setLoading(true);
      return removeCustomLineItemToCart({ itemId: lineItemId })
        .then((data) => {
          setLoading(false);
          setCartData({ cart: data });
        })
        .catch(() => {
          setLoading(false);
        });
    }

    setLoading(true);
    document.getElementById(lineItemId).classList.add(styles.checkedItem);

    removeFromCart({ lineItemId: lineItemId })
      .then((data) => {
        nostoUpdateCart(data);
        TagManager.removeFromCart(removedItem, data.cart);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleUpdateQty = (item, value) => {
    setLoading(true);
    updateCartItem({
      lineItemId: item.lineItemId,
      count: value,
    })
      .then((data) => {
        nostoUpdateCart(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className={styles.productList}>
      {items.map((item) => {
        const { type } = item;

        if (type === 'gift-card') {
          return (
            <GiftMiniCartItem
              item={item}
              key={item.lineItemId}
              capitalize={capitalize}
              removeFromCart={removeFromCartHandler}
              toSignUp={() => {
                signFormOpen(FORM_TYPE.LOGIN);
                showLoginErrorMessage();
              }}
              setLoading={setLoading}
            />
          );
        }
        return (
          <MiniCartItem
            type="minicart"
            key={item.lineItemId}
            item={item}
            capitalize={capitalize}
            onQtyUpdate={handleUpdateQty}
            removeFromCart={removeFromCartHandler}
            isLoggedIn={isLoggedIn}
            setShowDialog={setShowDialog}
            setLoading={setLoading}
            discounts={discounts}
            toSignUp={() => {
              setShowDialog(false);
              signFormOpen(FORM_TYPE.LOGIN);
              showLoginErrorMessage();
            }}
          />
        );
      })}
    </div>
  );
};

export default ProductList;
